import { render, staticRenderFns } from "./CreatePlanChooser.vue?vue&type=template&id=977d5548&scoped=true&"
import script from "./CreatePlanChooser.vue?vue&type=script&lang=js&"
export * from "./CreatePlanChooser.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlanChooser.vue?vue&type=style&index=0&id=977d5548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977d5548",
  null
  
)

export default component.exports